export type RestrictedAccessPageContent = {
  backLabel: string;
  title: string;
  subtitle: string;
  primaryActionLabel: string;
  secondaryLinkLabel?: string;
  secondaryLinkHref?: string;
};

export const GX_GO_PRICING_URL = 'https://www.general-index.com/pricing';

export const apiOnlyAccessPageContent: RestrictedAccessPageContent = {
  backLabel: 'Back',
  title: 'Your access is API-only',
  subtitle:
    'Your current plan includes API access only. Upgrade your plan to access GX Go features including market pages and dashboards.',
  primaryActionLabel: 'View plans',
  secondaryLinkLabel: 'Go to API Documentation',
  secondaryLinkHref: 'https://docs.g-x.co/#API'
};
